<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <div class="no-field-space">
    <form [formGroup]="form">
      <sc-flex>
        <sc-date-field formControlName="dateFrom"
          [label]="'from'| translate:['tmc-yard.widgets.sac-client.moving-order-dialog.planned-transports-date-from', translationService.language]">
        </sc-date-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-date-field formControlName="dateUntil"
          [label]="'to'| translate:['tmc-yard.widgets.sac-client.moving-order-dialog.planned-transports-date-to', translationService.language]">
        </sc-date-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-string-field formControlName="query"
          [label]="'query' | translate: ['tmc-yard.widgets.sac-client.moving-order-dialog.query', translationService.language]"
          [grow]="true">
        </sc-string-field>
        <sc-content-spacer></sc-content-spacer>
        <button mat-stroked-button (click)="refresh()"><sc-icon iconClass="fa-arrows-rotate"></sc-icon></button>
      </sc-flex>
    </form>
  </div>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <sc-flex-fitting-content [vertical]="true">
    <sc-scroll-pane>
      <table mat-table class="mat-table-selection" [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
        (matSortChange)="sortChanged($event)" [matSortDirection]="sortDirection">

        <ng-container matColumnDef="noRecord">
          <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
            {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}
          </td>
        </ng-container>

        <ng-container matColumnDef="hint">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'hint'| translate:['tmc-yard.entity.transport.hint', translationService.language]}}</th>
          <td mat-cell *matCellDef="let transport" [ngClass]="{'selected': selectedListEntry == transport}">
            <sc-flex>

              <app-transport-scope-icon [scope]="transport.transportScope" [type]="transport.transportType">
              </app-transport-scope-icon>

              <ng-container *ngIf="transport.useGlobalConnect">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-qrcode"></sc-icon>
              </ng-container>

              <ng-container *ngIf="transport.useSms">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-message-sms"></sc-icon>
              </ng-container>

              <ng-container *ngIf="transport.usePager">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-wifi"></sc-icon>
              </ng-container>

              <ng-container *ngIf="transport.important">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-exclamation"></sc-icon>
              </ng-container>

              <ng-container *ngIf="transport.urgent">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-truck-fast"></sc-icon>
              </ng-container>

              <ng-container *ngIf="transport.intermitted">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-octagon-xmark"></sc-icon>
              </ng-container>

              <ng-container *ngIf="transport.umbrueckung">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-shuffle"></sc-icon>
              </ng-container>

              <ng-container *ngIf="transport.dangerousGoods">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
              </ng-container>

              <ng-container *ngIf="transport.pendingTaskState !== PendingTaskState.NONE">
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <app-task-state-icon [state]="transport.pendingTaskState"></app-task-state-icon>
              </ng-container>

            </sc-flex>
          </td>
        </ng-container>

        <ng-container matColumnDef="carrier">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'carrier'| translate:['tmc-yard.entity.transport.masterdata.carrier', translationService.language]}}</th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.carrier}} </td>
        </ng-container>

        <ng-container matColumnDef="supplier">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'supplier'| translate:['tmc-yard.entity.transport.masterdata.supplier', translationService.language]}}
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.supplier}} </td>
        </ng-container>

        <ng-container matColumnDef="identifier">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'numberplate'| translate:['tmc-yard.entity.transport.masterdata.numberPlate',
            translationService.language]}}
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.identifier}} </td>
        </ng-container>

        <ng-container matColumnDef="driver">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'driver'| translate:['tmc-yard.entity.transport.masterdata.driverName', translationService.language]}}
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.driver}} </td>
        </ng-container>

        <ng-container matColumnDef="visitStatusDict">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'status'| translate:['tmc-yard.entity.transport.status', translationService.language]}}</th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}">
            <ng-container *ngIf="transport.status">
              {{transport.status | translate: ['tmc-yard.common.enum.transport-processing-status.' + transport.status,
              translationService.language]}}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="string1">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'string1'| translate:['tmc-yard.entity.transport.masterdata.string1', translationService.language]}}
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.string1}} </td>
        </ng-container>

        <ng-container matColumnDef="string2">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'string2'| translate:['tmc-yard.entity.transport.masterdata.string2', translationService.language]}}
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.string2}} </td>
        </ng-container>

        <ng-container matColumnDef="start">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'start'| translate:['tmc-yard.entity.transport.timing.start', translationService.language]}}</th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.start}} </td>
        </ng-container>

        <ng-container matColumnDef="reference">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'reference'| translate:['tmc-yard.entity.transport.masterdata.firstLoadCarrier.orderReference',
            translationService.language]}}
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.reference}} </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'options'| translate:['tmc-yard.entity.transport.options', translationService.language]}}</th>
          <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}">
            {{transport.options}}
          </td>
        </ng-container>

        <ng-container matColumnDef="cargo">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'cargo'| translate:['tmc-yard.entity.transport.cargo', translationService.language]}}</th>
          <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.cargo}}
          </td>
        </ng-container>

        <ng-container matColumnDef="planningDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'planningDate'| translate:['tmc-yard.entity.transport.planning-date',
            translationService.language]}}
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.planningDate}} </td>
        </ng-container>

        <ng-container matColumnDef="messagingResources">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'messagingResources'| translate:['tmc-yard.entity.transport.messaging-resources',
            translationService.language]}}
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.messagingResources}}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

        <tr mat-row *matRowDef="let transport; columns: columnsToDisplay" [attr.data-transport-id]="transport.id"
          [ngClass]="{'selected': selectedListEntry == transport}" (click)="toggleSelection(transport)"></tr>

        <tr [class.hide]="dataSource.data.length > 0" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
      </table>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
</sc-flex>
